import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import NameCellContent from './NameCellContent';

const NameCellWrapper = ({
  className,
  children,
  collapsing,
  colSpan,
  disabled,
  href,
  link,
  name,
  onClick,
}) => (
  <Table.Cell
    className={clsx('aridhia-name-cell-wrapper td-name', className)}
    collapsing={collapsing}
    colSpan={colSpan}
    disabled={disabled}
    title={name}
  >
    <NameCellContent disabled={disabled} name={name} href={href} link={link} onClick={onClick}>
      {children}
    </NameCellContent>
  </Table.Cell>
);

export default NameCellWrapper;
